export const update = {
  form: {
    method: '洗濯方法',
    detergentUsed: '使用洗剤',
    name: '方法名',
    washingTime: '洗浄時間',
    companyName: '会社名',
    detergentName: '洗剤名',
    quantity: '数量',
    unit: '単位',
    addNew: '新規追加',
    requireName: '洗浄プログラム名を入力してください',
    requireWashingTime: '洗浄時間を入力してください',
    requireCompanyName: '会社名を入力してください',
    requireDetergentName: '洗剤名を入力してください',
    requireQuantity: '水量/lを入力してください',
    requireUnit: '単位を入力してください',
    save: '保存',
    cancel: 'キャンセル',
    invalidLetters: '文字のみ入力できます。',
    invalidNumbers: '数字のみ入力できます。',
  },
  pageHeader: {
    title: '洗浄プログラムリスト　洗浄プログラム情報編集画面',
    back: '戻る',
  },
}
